export default __webpack_public_path__ + "static/media/spain.32e1e489.svg";